import { SalesData, IntegrationRatings, Indicator } from 'data/types/sales';
import formatPriceNumber from 'utils/formatPrice';

export const normalizeIntegrationRatings = (data: IntegrationRatings) => {
  return {
    name: data.name,
    totalSales: parseInt(data.totalSales, 10),
  };
};

export const normalizeIndicator = (
  data: number | string | Indicator,
  asPrice: boolean,
) => {
  if (typeof data === 'number' || typeof data === 'string') {
    return {
      value: asPrice ? formatPriceNumber(data) : data,
      change: 0,
    };
  }

  return {
    value: asPrice ? formatPriceNumber(data.value) : data.value,
    change: data.change,
  };
};

export const normalizeRevenue = (data: Record<string, string>) => {
  const revenue = Object.keys(data).map((key: string) => ({
    xAxis: key,
    yAxis: parseInt(data[key], 10),
  }));
  return revenue;
};

export const normalizeDailyOrders = (data: Record<string, number>) => {
  const daiLyOrders = Object.keys(data).map((key) => ({
    xAxis: key,
    yAxis: data[key],
  }));
  return daiLyOrders;
};

export const normalizeSales = (data: SalesData) => {
  return {
    updatedAt: data.updatedAt,
    totalSales: normalizeIndicator(data.totalSales, true),
    orders: normalizeIndicator(data.orders, false),
    ordersPerDay: normalizeIndicator(data.ordersPerDay, false),
    aov: normalizeIndicator(data.aov, true),
    revenue: normalizeRevenue(data.revenue),
    dailyOrders: normalizeDailyOrders(data.dailyOrders),
    integrationRatings: data.integrationRatings.map(
      normalizeIntegrationRatings,
    ),
  };
};

export type Sales = ReturnType<typeof normalizeSales>;
